import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../../i18n';

interface ResultErrorProps {
  message?: string;
  onRetry?: () => void;
}

export const ResultError: React.FC<ResultErrorProps> = ({ message, onRetry }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div style={{ maxWidth: '520px', margin: '40px auto', padding: '32px', background: 'var(--white)', borderRadius: '14px', border: '1px solid var(--line)', textAlign: 'center', display: 'grid', gap: '14px', boxShadow: '0 1px 3px rgba(0,0,0,0.02)' }}>
      <div style={{ width: '44px', height: '44px', borderRadius: '50%', background: 'var(--bad-soft)', color: 'var(--bad)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto', fontSize: '20px' }}>
        ⚠️
      </div>

      <h2 style={{ fontFamily: 'var(--display)', fontSize: '20px', fontWeight: 600, color: 'var(--navy)', margin: 0 }}>
        {t('scorecard.error_results_unavailable', undefined, 'Evaluation Results Unavailable')}
      </h2>

      <p style={{ fontSize: '13px', color: 'var(--muted)', margin: 0, lineHeight: 1.5 }}>
        {message || t('scorecard.error_default_msg', undefined, 'Could not retrieve evaluation results for this attempt. Please check your network connection and try again.')}
      </p>

      <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', paddingTop: '8px' }}>
        {onRetry && (
          <button
            type="button"
            onClick={onRetry}
            className="admin-btn admin-btn--primary admin-btn--sm"
          >
            {t('scorecard.retry_fetch_btn', undefined, 'Retry Fetch')}
          </button>
        )}
        <button
          type="button"
          onClick={() => navigate('/attempts')}
          className="admin-btn admin-btn--secondary admin-btn--sm"
        >
          {t('scorecard.my_attempts_nav', undefined, 'My Attempts')}
        </button>
      </div>
    </div>
  );
};
